module.exports = __webpack_public_path__ + "static/media/8C.eba08204.svg";